module.exports = __webpack_public_path__ + "static/media/portfolio-08 copy.4ac5cf25.jpg";